export const FUEL_TYPES_WITH_BATTERY = [
  "Sähkö",
  "Bensiini/Hybridi",
  "Diesel/Hybridi"
];

export const FUEL_TYPE_OPTIONS = [
  "Bensiini",
  "Diesel",
  "Hybridi",
  "Sähkö",
  "Kaasu",
  "E85/Bensiini",
  "Bensiini/Hybridi",
  "Diesel/Hybridi"
];

export const POWER_TYPE_QUICK_FILTERS = [
  "Bensiini",
  "Sähkö",
  "Hybridi"
] as const;

export type PowerTypeQuickFilter = (typeof POWER_TYPE_QUICK_FILTERS)[number];

/**
 * Buckets a raw fuelType value (e.g. "Bensiini/Hybridi") into one of the quick-filter
 * groups. Order matters: Hybridi is checked first so compound hybrid values never fall
 * into Bensiini/Sähkö. Diesel and Kaasu are out of scope and return null.
 */
export const getPowerTypeGroup = (
  fuelType?: string
): PowerTypeQuickFilter | null => {
  if (!fuelType) return null;
  if (fuelType.includes("Hybridi")) return "Hybridi";
  if (fuelType.includes("Sähkö")) return "Sähkö";
  if (fuelType.includes("Bensiini")) return "Bensiini";
  return null;
};

export const DRIVE_TYPE_OPTIONS = ["Etuveto", "Takaveto", "Neliveto"];

export const GEAR_TYPE_OPTIONS = ["Manuaali", "Automaatti"];

export const ENGINE_SIZE_OPTIONS = Array.from({ length: 100 }, (_, i) =>
  Number(((i + 1) / 10).toFixed(1))
);

export const SNOWMOBILE_BIKE_TYPE_ID = 6;
export const ATV_BIKE_TYPE_ID = 16;

/** Nettix Nettiauto API vehicleTypeId for caravan (motorhome, caravan, trailer) */
export const CARAVAN_VEHICLE_TYPE_ID = 2;
